export default __webpack_public_path__ + "static/media/GlobalAdmin.4a628053.svg";